<template>
  <q-item
    v-ripple="clickable && !disable"
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item relative-position"
    @click="$emit('click')"
  >
    <slot name="before" />
    <q-item-section
      :class="{'no-pointer-events': clickable}"
    >
      <q-item-label
        class="module-name"
        :class="{'text-orange-9': template.is_beta}"
      >
        {{ template.title }}
      </q-item-label>
      <q-item-label caption>
        <span
          v-if="template.standard"
          class="q-mr-sm"
        >
          {{ template.standard }}
        </span>
        <span
          class="text-bold"
        >
          Version {{ template.master_version }}.{{ template.minor_version }} ({{ template.is_master ? 'Master' : 'Edited' }} Copy)
        </span>
      </q-item-label>
      <q-item-label v-if="withDescription && template.description" caption>
        <nl2br
          tag="div"
          class="q-pt-sm"
          :text="template.description"
        />
      </q-item-label>
    </q-item-section>
    <q-item-section v-if="template.is_beta" side>
      <q-chip
        color="orange-9"
        dark
        dense
      >
        Beta
      </q-chip>
    </q-item-section>
    <q-item-section
      v-if="withStatus && ['DRAFT', 'ARCHIVED'].includes(template.status)"
      side
    >
      <q-chip
        v-if="template.status === 'ARCHIVED'"
        color="red-7"
        dark
        dense
      >
        Archived
      </q-chip>
      <q-chip
        v-else-if="template.status === 'DRAFT'"
        dark
        dense
        color="blue-grey-7"
      >
        Draft
      </q-chip>
    </q-item-section>
    <slot />
  </q-item>
</template>

<script>
import itemMixin from 'src/helpers/item'

export default {
  mixins: [itemMixin],
  props: {
    template: {
      type: Object,
      required: true
    },
    withStatus: {
      type: Boolean,
      default: true
    },
    withDescription: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>
